import {
    ADMIN_COUNT_FAIL,
    ADMIN_COUNT_REQUEST,
    ADMIN_COUNT_SUCCESS,
    ARTISAN_COUNT_FAIL,
    ARTISAN_COUNT_REQUEST,
    ARTISAN_COUNT_SUCCESS,
    ARTISAN_PRODUCT_COUNT_FAIL,
    ARTISAN_PRODUCT_COUNT_REQUEST,
    ARTISAN_PRODUCT_COUNT_SUCCESS,
    ORDER_COUNT_FAIL,
    ORDER_COUNT_REQUEST,
    ORDER_COUNT_SUCCESS,
    ORDER_DELIVERED_COUNT_FAIL,
    ORDER_DELIVERED_COUNT_REQUEST,
    ORDER_DELIVERED_COUNT_SUCCESS,
    ORDER_PAID_COUNT_FAIL,
    ORDER_PAID_COUNT_REQUEST,
    ORDER_PAID_COUNT_SUCCESS,
    PRODUCT_COUNT_FAIL,
    PRODUCT_COUNT_REQUEST,
    PRODUCT_COUNT_SUCCESS,
    USER_COUNT_FAIL,
    USER_COUNT_REQUEST,
    USER_COUNT_SUCCESS,
    USER_REPORT_COUNT_FAIL,
    USER_REPORT_COUNT_REQUEST,
    USER_REPORT_COUNT_SUCCESS
} from "../constants/CountConstants";


export const userCountReducer = (state = { users: {} }, { type, payload }) => {

    switch (type) {
        case USER_COUNT_REQUEST:
            return {
                loading: true,
            }

        case USER_COUNT_SUCCESS:
            return {
                loading: false,
                users: payload
            }

        case USER_COUNT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}



export const artisanCountReducer = (state = { artisans: {} }, { type, payload }) => {

    switch (type) {
        case ARTISAN_COUNT_REQUEST:
            return {
                loading: true,
            }

        case ARTISAN_COUNT_SUCCESS:
            return {
                loading: false,
                artisans: payload
            }

        case ARTISAN_COUNT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}



export const adminCountReducer = (state = { admins: {} }, { type, payload }) => {

    switch (type) {
        case ADMIN_COUNT_REQUEST:
            return {
                loading: true,
            }

        case ADMIN_COUNT_SUCCESS:
            return {
                loading: false,
                admins: payload
            }

        case ADMIN_COUNT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}



export const productCountReducer = (state = { products: {} }, { type, payload }) => {

    switch (type) {
        case PRODUCT_COUNT_REQUEST:
            return {
                loading: true,
            }

        case PRODUCT_COUNT_SUCCESS:
            return {
                loading: false,
                products: payload
            }

        case PRODUCT_COUNT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}



export const artisanProductCountReducer = (state = { artisan_products: {} }, { type, payload }) => {

    switch (type) {
        case ARTISAN_PRODUCT_COUNT_REQUEST:
            return {
                loading: true,
            }

        case ARTISAN_PRODUCT_COUNT_SUCCESS:
            return {
                loading: false,
                artisan_products: payload
            }

        case ARTISAN_PRODUCT_COUNT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}


export const orderCountReducer = (state = { orders: {} }, { type, payload }) => {

    switch (type) {
        case ORDER_COUNT_REQUEST:
            return {
                loading: true,
            }

        case ORDER_COUNT_SUCCESS:
            return {
                loading: false,
                orders: payload
            }

        case ORDER_COUNT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}




export const orderPaidCountReducer = (state = { order_paid: {} }, { type, payload }) => {

    switch (type) {
        case ORDER_PAID_COUNT_REQUEST:
            return {
                loading: true,
            }

        case ORDER_PAID_COUNT_SUCCESS:
            return {
                loading: false,
                order_paid: payload
            }

        case ORDER_PAID_COUNT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}



export const orderDeliveredCountReducer = (state = { order_delivered: {} }, { type, payload }) => {

    switch (type) {
        case ORDER_DELIVERED_COUNT_REQUEST:
            return {
                loading: true,
            }

        case ORDER_DELIVERED_COUNT_SUCCESS:
            return {
                loading: false,
                order_delivered: payload
            }

        case ORDER_DELIVERED_COUNT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}



export const userReportCountReducer = (state = { user_report: {} }, { type, payload }) => {

    switch (type) {
        case USER_REPORT_COUNT_REQUEST:
            return {
                loading: true,
            }

        case USER_REPORT_COUNT_SUCCESS:
            return {
                loading: false,
                user_report: payload
            }

        case USER_REPORT_COUNT_FAIL:
            return {
                loading: false,
                error: payload
            }

        default:
            return state;
    }
}